var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"v-icon__svg iconRight",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","role":"img","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }